import "./CouplingPage.scss"

import { Banner, Button, TextTag as Text } from "../../atoms"
import {
  CHANGE_PARTNER,
  CHECK_RESTAURANTS,
  COUPLING_TEXT,
  DEFAULT_SPACE_NAME,
  INVITE_RESEND_BANNER,
  INVITE_RESEND_BANNER_SUB_HEADING,
  INVITE_RESEND_BUTTON,
  NOTIFY_BACK_BUTTON,
  PARTNER_ACCEPTED_INVITE,
  JOURNAL_LABEL,
} from "../../constants/messages"
import { Col, Row } from "antd"
import {
  FIREBASE_STATE_KEYS,
  FirebaseContext,
  FirebaseService,
} from "../../firebase"
import React, { useEffect, useState } from "react"
import {
  fetchPartnerDetails,
  inviteByEmail,
  inviteByPhone,
} from "../../redux/actionCreators/invitePeople"
import { getPartnerNameorNickName } from "../../utils/helpers"
import BlockingModal from "../../components/BlockingModal/BlockingModal"
import ChatHeader from "../../components/ChatHeader/ChatHeader"
import _ from "../../utils/lodashUtils"
import { connect } from "react-redux"
import femaleIcon from "../../assets/images/female_artwork.svg"
import maleIcon from "../../assets/images/male_artwork.svg"
import { withRouter } from "react-router-dom"
import { phone } from "../../constants/validationMessages"

const CouplingPage = ({
  user,
  invite,
  history,
  inviteByEmail,
  inviteByPhone,
  fetchPartnerDetails,
}) => {
  let user_address = ""
  if (user.address) user_address = user.address.user_address
  const userId = _.get(user, "uuid")
  const { userState, partnerState } = React.useContext(FirebaseContext)
  const notifyInvite = _.get(
    userState,
    FIREBASE_STATE_KEYS.NOTIFY_INVITE,
    false
  )
  const [notifyPartnerModal, setNotifyPartnerModal] = useState(true)
  const chatSpaceName = notifyInvite.chatSpaceName || DEFAULT_SPACE_NAME
  const partnerName = getPartnerNameorNickName(
    partnerState,
    "",
    invite.partnerDetails
  )
  useEffect(() => {
    fetchPartnerDetails()
  }, [])

  const checkRestaurants = () => {
    history.push("/check-restaurants")
  }

  const goToChangepartner = () => {
    history.push("/my-partner")
  }

  const resendInvite = () => {
    if (invite.invitationType.toUpperCase() === phone.toUpperCase())
      inviteByPhone(
        { inviteeMobile: invite.partnerDetails.partner2_identifier },
        invite.partnerDetails.partner2_nickname,
        true
      ).catch()
    else
      inviteByEmail(
        { inviteeEmail: invite.partnerDetails.partner2_identifier },
        invite.partnerDetails.partner2_nickname,
        true
      ).catch()
  }

  return (
    <div id="couplingPage">
      <ChatHeader />
      <BlockingModal
        title={PARTNER_ACCEPTED_INVITE(partnerName)}
        blockingModalVisibility={notifyInvite && notifyPartnerModal}
        continueHandler={() => {
          FirebaseService.delete(
            `${FirebaseService.getDefaultPath()}${userId}/notifyInvite`
          )
          setNotifyPartnerModal(false)
        }}
        buttonText={NOTIFY_BACK_BUTTON(partnerName)}
      />
      {!_.isEmpty(invite.partnerDetails) &&
      _.get(invite, "partnerDetails.partner2_status") === "PENDING" ? (
        <div className="coupling_banner">
          <Banner type="secondary">
            <div className="nudge-banner-container">
              <div>
                <Text textType="sectionHeading" className="banner-text">
                  {INVITE_RESEND_BANNER(
                    _.get(invite, "partnerDetails.partner2_nickname")
                  )}
                </Text>
                <br />
                <Text textType="sectionTextPrimary" className="banner-text">
                  {INVITE_RESEND_BANNER_SUB_HEADING}
                </Text>
              </div>
              <div className="banner-buttons">
                <Button className="notify-button" onClick={resendInvite}>
                  {INVITE_RESEND_BUTTON}
                </Button>
                <Button
                  className="change_partner_button"
                  onClick={goToChangepartner}
                >
                  {CHANGE_PARTNER}
                </Button>
              </div>
            </div>
          </Banner>
        </div>
      ) : null}
      <div className="couplingDetails">
        <div className="couplingImage">
          {user.gender === "FEMALE" ? (
            <img src={femaleIcon} alt="Female" />
          ) : (
            <img src={maleIcon} alt="Male" />
          )}
        </div>
        <Row id="couplingText">
          <p className="coupleText">{COUPLING_TEXT}</p>
        </Row>
        <Row id="buttonPlacements">
          <Col span={20}>
            <Button
              className="update_profile"
              btnType="primary"
              btnSize="large"
              onClick={() => {
                const location = {
                  pathname: "/meet-concierge",
                  state: { fromLogin: false },
                }
                history.push(location)
              }}
            >
              {JOURNAL_LABEL(chatSpaceName)}
            </Button>
          </Col>
          {/* <Col span={4}></Col>
          <Col span={10}> */}
          {/* As per ada's comments hiding it */}
          {/* <Button
              btnType="primary"
              btnSize="large"
              onClick={checkRestaurants}
            >
              {CHECK_RESTAURANTS}
            </Button>
          </Col> */}
        </Row>
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  isAuthenticated: _.get(state, "auth.isAuthenticated"),
  user: _.get(state, "auth.user"),
  invite: _.get(state, "invitePeople"),
})

export default connect(mapStateToProps, {
  inviteByEmail,
  inviteByPhone,
  fetchPartnerDetails,
})(withRouter(CouplingPage))
